import React from 'react';
import clsx from 'clsx';
import styles from './FormActions.module.scss';

const FormActions = ({ children }) => {
  const className = clsx(
    styles.FormActions
  );

  return (
    <div className={className}>
      {children}
    </div>
  );
};

export default FormActions;
